import styled, { css } from "styled-components";
import { getTypographyStyles } from "@security-watchdog/sw-ui-kit";

interface IProofWithMobile {
  isMobile: boolean;
}
export const ContentContainer = styled.div<IProofWithMobile>`
  display: flex;
  margin-top: 25px;
  gap: 24px;
  ${({ isMobile }) => isMobile && "flex-direction: column;"}
`;

export const MainContent = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

export const ContainerAttachDocuments = styled.div`
  margin-bottom: 16px;
  background-color: ${({ theme }) => theme.colors["color-surface-default"]};
  padding: 24px;
`;

export const InfoContainer = styled.div<IProofWithMobile>`
  background-color: ${({ theme }) => theme.colors["color-surface-default"]};
  padding: 15px 24px;
  width: 280px;
  display: flex;
  flex-direction: column;
  ${({ isMobile }) => isMobile && "width: auto;"}
`;

export const InfoTitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
`;

export const InfoTitle = styled.div`
  ${getTypographyStyles({ variant: "body-highlight" })};
`;

export const InfoDescription = styled.div`
  ${getTypographyStyles({ variant: "body-wide-line" })};
`;

export const ContainerButtons = styled.div<IProofWithMobile>`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  ${({ isMobile }) =>
    isMobile &&
    css`
      flex-direction: column;
      gap: 16px;
    `}
`;

export const ErrorText = styled.div`
  margin-top: 8px;
`;
